module.exports = __webpack_public_path__ + "img/29_51.1fdeaac9.png";